import * as React from 'react';

import { SectionVocabQuestionListGroupLayout } from '@doltech/domains/vocab/shared/ui/SectionVocabQuestionListGroup/SectionVocabQuestionListGroupLayout';
import { useFromScreens } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { ButtonIconDictationQuestionList } from '../ButtonIconDictationQuestionList/ButtonIconDictationQuestionList';
import { SectionDictationQuestionList } from '../SectionDictationQuestionList/SectionDictationQuestionList';
import { SectionDictationQuestionListGroup } from '../SectionDictationQuestionListGroup/SectionDictationQuestionListGroup';
import { DICTATION_LIST_TOGGLE_ID } from '../../../shared/constant';

interface StudentDictationQuestionListProps {
  visible?: boolean;
  questions: any;
  setVisible?: (visible?: boolean) => void;
  goToQuestion?: (questionIndex: number) => void;
}

export const StudentDictationQuestionList = (props: StudentDictationQuestionListProps) => {
  const { visible, setVisible, questions, goToQuestion } = props;
  const [, from600, from1280] = useFromScreens([0, 600, 1280]);

  const handleGoToQuestion = (selectedKey) => {
    goToQuestion?.(selectedKey);
  };

  if (from1280) {
    return visible ? (
      <SectionDictationQuestionList
        type="default"
        onClose={() => setVisible(false)}
        groupContent={
          <SectionDictationQuestionListGroup
            type="default"
            questions={questions}
            onSelect={handleGoToQuestion}
          />
        }
      />
    ) : (
      <ButtonIconDictationQuestionList onClick={() => setVisible(true)} />
    );
  }

  if (from600) {
    return (
      visible && (
        <SectionDictationQuestionList
          type="pop-up"
          triggerElement={document.getElementById(DICTATION_LIST_TOGGLE_ID)}
          onClose={() => setVisible?.(false)}
          groupContent={
            <SectionDictationQuestionListGroup
              type="pop-up"
              questions={questions}
              onSelect={(selectedKey) => {
                setVisible(false);
                handleGoToQuestion(selectedKey);
              }}
            />
          }
        />
      )
    );
  }

  return (
    visible && (
      <SectionDictationQuestionList
        type="bottom-sheet"
        onClose={() => setVisible(false)}
        groupContent={
          <SectionVocabQuestionListGroupLayout>
            <SectionDictationQuestionListGroup
              type="bottom-sheet"
              questions={questions}
              onSelect={(selectedKey) => {
                setVisible(false);
                handleGoToQuestion(selectedKey);
              }}
            />
          </SectionVocabQuestionListGroupLayout>
        }
      />
    )
  );
};
